// extracted by mini-css-extract-plugin
export default {"community":"RnDCommunity_community__70yAZ","communityText":"RnDCommunity_communityText__xVBIx","communityImage":"RnDCommunity_communityImage__I1ijh"};